/* LUVIRE first-party measurement. Never read form values or order properties. */
(function (w) {
  'use strict';
  if (w.LuvirePaid) return;
  const ENDPOINT = 'https://api.luvire.store/analytics/events';
  const FIELDS = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term',
    'campaign_id','adset_id','ad_id','creative_id','zone_id','subzone_id','click_id',
    'placement','format','device','os','browser','landing_variant'];
  const EVENTS = ['landing_view','dob_started','dob_submitted','result_viewed',
    'grimoire_clicked','add_to_cart','cart_error','attribution_error'];
  const STORAGE = 'luvire_paid_v2', TTL = 30 * 60 * 1000;
  const aliases = {campaign_id:'campaignid',creative_id:'bannerid',zone_id:'zoneid',click_id:'clickid'};
  const clean = v => typeof v === 'string' && /^[A-Za-z0-9_.~-]{1,128}$/.test(v) ? v : '';
  let state = null, captured = false, cartWrite = Promise.resolve();
  function identifier() {
    // Older WebViews have getRandomValues but no randomUUID. Never use an ID
    // derived from customer information, or let an unavailable API break buying.
    const crypto = w.crypto;
    if (!crypto) return '';
    if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    if (typeof crypto.getRandomValues !== 'function') return '';
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    return Array.from(bytes, b => ('0' + b.toString(16)).slice(-2)).join('');
  }
  function landingVariant() {
    return /^\/products\/personal-grimoire\/?$/.test(w.location.pathname) ? 'grimoire_book_v1' : 'home_book_v1';
  }
  function allowed() {
    try {
      const p = w.Shopify.customerPrivacy;
      return p.analyticsProcessingAllowed() === true && p.marketingAllowed() === true && p.saleOfDataAllowed() === true;
    } catch (_) { return false; }
  }
  function save() { try { w.sessionStorage.setItem(STORAGE, JSON.stringify(state)); } catch (_) {} }
  function context() {
    if (!allowed()) {
      state = null;
      try { w.sessionStorage.removeItem(STORAGE); } catch (_) {}
      return null;
    }
    const now = Date.now();
    if (!state) {
      try {
        const old = JSON.parse(w.sessionStorage.getItem(STORAGE));
        if (old && clean(old.session_id) && Number.isFinite(old.updated) && now-old.updated < TTL && old.updated <= now) {
          state = {session_id:old.session_id,updated:old.updated,seen:{}};
          FIELDS.forEach(k => { if (clean(old[k])) state[k] = old[k]; });
          EVENTS.forEach(k => { if (old.seen && old.seen[k] === true) state.seen[k] = true; });
        }
      } catch (_) {}
    }
    const incoming = {}, params = new URLSearchParams(w.location.search);
    FIELDS.forEach(k => {
      const value = clean(params.get(k) || (aliases[k] ? params.get(aliases[k]) : ''));
      if (value) incoming[k] = value;
    });
    const tagged = incoming.click_id || incoming.utm_source || incoming.campaign_id;
    if (!captured && tagged && state && Object.keys(incoming).some(k => incoming[k] !== state[k])) state = null;
    if (!state || now-state.updated >= TTL) {
      const id = identifier();
      if (!id) return null;
      state = Object.assign({session_id:id,seen:{},landing_variant:landingVariant()},incoming);
    }
    captured = true;
    state.updated = now;
    save();
    const result = {session_id:state.session_id,landing_variant:'root_v2'};
    FIELDS.forEach(k => { if (clean(state[k])) result[k] = state[k]; });
    return result;
  }
  async function deliver(payload) {
    // Retry the identical ID; the collector deduplicates. Never retry after consent withdrawal.
    for (let attempt=0; attempt<2 && allowed(); attempt++) {
      try {
        const response = await w.fetch(ENDPOINT, {method:'POST',credentials:'omit',
          headers:{'Content-Type':'text/plain'},body:JSON.stringify(payload),keepalive:true});
        if (response.ok || (response.status >= 400 && response.status < 500 && response.status !== 429)) return;
      } catch (_) {}
    }
  }
  function emit(name) {
    try {
      if (!EVENTS.includes(name)) return false;
      const c = context();
      if (!c) return false;
      const once = !['add_to_cart','cart_error','attribution_error'].includes(name);
      if (once && state.seen[name]) return false;
      const id = identifier();
      if (!id) return false;
      const payload = Object.assign({},c,{event:'luvire_'+name,event_id:id,occurred_at:new Date().toISOString()});
      state.seen[name] = true; save();
      // Shopify custom event is diagnostic/available for intentional subscriptions, never a second Meta/GA4 Purchase.
      try { if (w.Shopify && w.Shopify.analytics && typeof w.Shopify.analytics.publish === 'function') w.Shopify.analytics.publish(payload.event,payload); } catch (_) {}
      void deliver(payload);
      return true;
    } catch (_) { return false; }
  }
  function persistCart() {
    const write = async () => {
      let timer;
      try {
        const c = context(), attributes = {};
        FIELDS.concat('session_id').forEach(k => { attributes['luvire_'+k] = (c && c[k]) || ''; });
        attributes.luvire_tracking_permission = c ? 'granted' : 'denied';
        attributes.luvire_attribution_at = c ? new Date().toISOString() : '';
        const controller = typeof AbortController === 'function' ? new AbortController() : null;
        const timeout = new Promise((_, reject) => {
          timer = w.setTimeout(() => {
            if (controller) controller.abort();
            reject(new Error('attribute_update_timeout'));
          },2500);
        });
        const response = await Promise.race([timeout,w.fetch(((w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/')+'cart/update.js', {
          method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({attributes}),signal:controller ? controller.signal : undefined})]);
        if (!response.ok) throw new Error('attribute_update_failed');
        return true;
      } catch (_) { emit('attribution_error'); return false; }
      finally { if (timer) w.clearTimeout(timer); }
    };
    cartWrite = cartWrite.then(write,write);
    return cartWrite;
  }
  w.LuvirePaid = {emit,persistCart};
  function ready() {
    if (w.location.pathname === '/' || /^\/products\/personal-grimoire\/?$/.test(w.location.pathname)) emit('landing_view');
  }
  w.document.addEventListener('visitorConsentCollected', () => {
    ready();
    if (!allowed()) void persistCart();
  });
  w.document.addEventListener('DOMContentLoaded',ready);
  if (w.Shopify && typeof w.Shopify.loadFeatures === 'function') w.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error => { if (!error) ready(); });
  ready();
}(window));
